let uuid = 0

/**
 * A unique id is added to the component where this mixin is used.
 */
export default {
  beforeCreate() {
    this.uuid = uuid.toString()
    uuid += 1
  }
}
